<div class="notification__image-wrapper">
  <pp-icon class="notification__image" [ppSrc]="EIconPath.NOTIFICATION_ICON_COMMENT" ppColor="primary-950"></pp-icon>
</div>

<span>
  <span class="notification__blue-text">{{ 'commented' | ppTranslate }}</span>
  {{ 'on_a_point_you' | ppTranslate }} {{ notificationReason }}:
</span>
